import { GetInvoiceModel } from "@factory/model/query-model-invoice";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { invoiceFormDefault } from "./form.default";
import { InvoiceFormSchema } from "./form.rule";

export const useFormDefaultInvoice = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetInvoiceModel | undefined) => {
    return !cachedValue
      ? invoiceFormDefault
     : ({
        baseQuote: cachedValue.base_quote,
        invoiceDate: cachedValue.invoice_date,
        dueDate: cachedValue.due_date,
        amount: cachedValue.amount,
      } as InvoiceFormSchema);
  };

  return {
    getDefault,
  };
};
